import { defineAsyncComponent } from 'vue';

export const TableFilterMerchantManagement = defineAsyncComponent(() => import('./TableFilterMerchantManagement.vue'));
export const TableActionMerchantManagement = defineAsyncComponent(() => import('./TableActionMerchantManagement.vue'));
